module.exports = __webpack_public_path__ + "static/media/landing_video.9ca5e99c.mp4";